export default __webpack_public_path__ + "static/media/introductionicon.d940c275.svg";